import React from 'react';
import { Stepper, Breadcrumbs } from '../../library/common/components';
import { connect } from 'react-redux';
import { routes } from '../../main/routes';

const Quote = (props) => {
  const crumbs = routes
    .filter(({ path }) => props.match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(props.match.params).length
        ? Object.keys(props.match.params).reduce(
          (path, param) => path.replace(
            `:${param}`, props.match.params[param]
          ), path
          )
        : path,
      ...rest
    }));

  return (
    <div>
      <Breadcrumbs crumbs={crumbs} title={'Calcula tu reforma'}/>
      <Stepper steps={props.steps}></Stepper>
    </div>
  );
}

const mapStateToProps = ({ quote }) => {
  return {
    steps: quote.steps,
  }
};

export default connect(mapStateToProps)(Quote);
